import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable, DataTablePFSEvent } from "primereact/datatable";
import { UserRoles } from "../../../../../constants/userRoles";
import { PrivateAccess } from "../../../../../keycloak";

import classes from "./InventoryList.module.scss";

type InventoryListProps = {
  first?: number;
  rows?: number;
  totalRecords?: number;
  records: [any];
  rowActionEdit: (rowData: any) => void;
  rowActionDelete: (rowData: any) => void;
  onPage: (e: DataTablePFSEvent) => void;
};

export const InventoryList = ({
  first,
  rows,
  totalRecords,
  records,
  rowActionDelete,
  rowActionEdit,
  onPage,
}: InventoryListProps) => {
  const actionBodyTemplate = (rowData: any) => {
    return (
      <div className={classes.tableActions}>
        <PrivateAccess
          roles={{
            dcs_client: [UserRoles.INVENTORY_UPDATE],
          }}
        >
          <Button
            icon="pi pi-pencil"
            className="p-button-primary mr-2 p-button-sm"
            onClick={() => rowActionEdit(rowData)}
          />
        </PrivateAccess>
        <PrivateAccess
          roles={{
            dcs_client: [UserRoles.INVENTORY_DELETE],
          }}
        >
          <Button
            icon="pi pi-trash"
            className="p-button-danger p-button-sm"
            onClick={() => rowActionDelete(rowData)}
          />
        </PrivateAccess>
      </div>
    );
  };

  return (
    <DataTable
      value={records}
      paginator={true}
      paginatorTemplate="PrevPageLink CurrentPageReport NextPageLink"
      first={first}
      rows={rows}
      totalRecords={totalRecords}
      onPage={onPage}
      paginatorPosition="top"
      paginatorClassName={classes.paginator}
      lazy
    >
      <Column field="name" header="Inventory Name"></Column>
      <Column field="number" header="Inventory Number"></Column>
      <Column
        style={{ width: "150px" }}
        body={actionBodyTemplate}
        header="Actions"
      ></Column>
    </DataTable>
  );
};
